import { FunctionComponent, useState } from "react";
import { DmsManufacturer } from "../../../models/features/ShoppingPortal/DmsManufacturer";
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material";
import { capitalizeFirstLetter } from "../../../services/utilities/utility";
import { useNavigate } from "react-router-dom";

interface PortalManufacturerItemProps {
  manufacturer: DmsManufacturer;
}

const PortalManufacturerItem: FunctionComponent<
  PortalManufacturerItemProps
> = ({ manufacturer }) => {
  const navigate = useNavigate();
  const onMfrChange = (mfr: DmsManufacturer) => {
    navigate(
      "/ShoppingPortal/EmbeddedParts" +
        window.location.search +
        `&mfrCode=${mfr.code}&mfrName=${mfr.name}&view=grid`
    );
  };

  return (
    <Card sx={{ maxWidth: 345 }}>
      <CardActionArea onClick={() => onMfrChange(manufacturer)}>
        {manufacturer?.catalogManufacturer?.imageUrl ? (
          <CardMedia
            sx={{ height: 200 }}
            image={manufacturer.catalogManufacturer.imageUrl}
            title={manufacturer.name}
          />
        ) : (
          <Box
            sx={{
              height: 200,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#f0f0f0",
            }}
          >
            <Typography variant="h6" color="#000">
              {capitalizeFirstLetter(manufacturer.name)}
            </Typography>
          </Box>
        )}
        <CardContent style={{ textAlign: "center", padding: 6 }}>
          <Typography
            gutterBottom
            component="div"
            style={{ transform: "none" }}
          >
            {capitalizeFirstLetter(manufacturer.name)}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default PortalManufacturerItem;
